import { Button } from "@nextui-org/react";
import { Helmet } from 'react-helmet';
import { toDataURL } from 'qrcode';
import {
    ShareIcon6White
} from "../images/svgs";

export const downloadQRCode = async (text, fileName) => {
    try {
        const dataUrl = await toDataURL(text, { width: 512 });
    
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = fileName;
        link.click();
    } catch (err) {

    }
}

export const getCurrentDate = (separator='-') => {
    let newDate = new Date()
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date<10?`0${date}`:`${date}`}`
}

export const HelmetWrapper = ({ title, description, url }) => {
    return (
        <Helmet>
            {/* Open Graph Meta Tags */}
            <meta property="og:title" content={title || "JudgeAutos – Car Show Management Web App"} />
            <meta property="og:description" content={description || "A web-based app for managing car show participants, registration, judging, and results, making shows more efficient and organized."} />
            <meta property="og:url" content={url ? `https://judgeautos.com/${url}` : "https://judgeautos.com"} />

            {/* Other Meta Tags */}
            <title>{title || "JudgeAutos – Web-based Car Show App"}</title>
            <meta
                name="description"
                content={
                    description ||
                    "JudgeAutos is a web app for managing car show participants, registration, judging, results, and overall event organization."
                }
            />
        </Helmet>
    )
}

export const textToClipboard = async (text) => {
    if (typeof window === "undefined") return false;

    try {
        if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
        
        const el = document.createElement("textarea");
        el.value = text;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);

        return true;
    } catch {
        return false;
    }
}

export const HandleWebShare = ({ title, text, url }) => {
    const fallbackShare = async () => {
        try {
            await navigator.clipboard.writeText(url || window.location.href);
            alert("Link copied to clipboard");
        } catch {
            const shareUrl = encodeURIComponent(url || window.location.href);
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,"_blank");
        }
    };
    
    if (navigator?.share && window.isSecureContext) {
        navigator.share({
            title: title || "Check this out!",
            text: text || "",
            url: url || window.location.href,
        })
    } else {
        fallbackShare();
    }
}